import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { ActivatedRoute } from '@angular/router';
import { combineLatest, Subject } from 'rxjs';
import { filter, map, take, takeUntil } from 'rxjs/operators';

import { SubscriptionPlan } from '@vi-iot/client';

import { BookingStore, BOOKING_TABS, InstallationsStore, BookingQueryParams } from '@store';

@Component({
  selector: 'app-booking',
  templateUrl: './booking.component.html',
  styleUrls: ['./booking.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BookingComponent implements OnInit, OnDestroy {
  currentStep = BOOKING_TABS.SELECT_PLAN;

  private selectedPlan: SubscriptionPlan;
  protected boilerSerial: string;
  private ngUnsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    public bookingStore: BookingStore,
    public installationsStore: InstallationsStore,
    public route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.bookingStore.resetUserSelection();
    this.bookingStore.loadInstallations();
    this.bookingStore.getAllVitoguideSubscriptions();

    combineLatest([this.route.queryParams, this.installationsStore.installations$])
      .pipe(
        filter(([_params, installations]) => installations && !!installations.length),
        map(([params]): BookingQueryParams => params as BookingQueryParams),
        take(1),
        takeUntil(this.ngUnsubscribe$)
      )
      .subscribe((params) => {
        if (Object.keys(params).length > 0) {
          this.boilerSerial = params?.boilerSerial;
          this.bookingStore.fetchSubscriptionsPlans();

          if (params?.selectedStep === BOOKING_TABS.CHECKOUT) {
            this.currentStep = params.selectedStep;
            this.bookingStore.selectPlan(SubscriptionPlan.Pro);
          }
        }
        this.bookingStore.loadBookingInstallation();
      });

    this.bookingStore.selectedPlan$.pipe(takeUntil(this.ngUnsubscribe$)).subscribe((plan) => {
      this.selectedPlan = plan;
    });
  }

  nextStep(stepper: MatStepper): void {
    stepper.selected.completed = true;
    stepper.next();
  }

  previousStep(stepper: MatStepper): void {
    stepper.selected.completed = false;
    stepper.previous();
  }

  initialStep(stepper: MatStepper): void {
    stepper.reset();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }

  navigateToCheckout(stepper: MatStepper): void {
    stepper.selectedIndex = 2;

    if (this.selectedPlan === SubscriptionPlan.Trial) {
      this.bookingStore.createTrialSubscription();
    } else {
      this.bookingStore.getSubscriptionsDetails(this.boilerSerial);
    }
  }
}
